// extracted by css-extract-rspack-plugin
export default {"selector":"selector-c3AFw6","header":"header-t8mtKE","paramList":"paramList-x4IyND"};